"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var addSubDev_1 = __importDefault(require("./addSubDev"));
var appSendResp_1 = __importDefault(require("./appSendResp"));
var devLogin_1 = __importDefault(require("./devLogin"));
var devSend_1 = __importDefault(require("./devSend"));
var devSyncResp_1 = __importDefault(require("./devSyncResp"));
var gatewayLogin_1 = __importDefault(require("./gatewayLogin"));
var getTimerList_1 = __importDefault(require("./getTimerList"));
var heartbeat_1 = __importDefault(require("./heartbeat"));
var reportDevInfo_1 = __importDefault(require("./reportDevInfo"));
var reportSubDevInfo_1 = __importDefault(require("./reportSubDevInfo"));
var requestVerify_1 = __importDefault(require("./requestVerify"));
var timerReport_1 = __importDefault(require("./timerReport"));
exports.default = (function (virtual) { return ({
    addSubDev: addSubDev_1.default(virtual),
    appSendResp: appSendResp_1.default(virtual),
    devLogin: devLogin_1.default(virtual),
    devSend: devSend_1.default(virtual),
    devSyncResp: devSyncResp_1.default(virtual),
    gatewayLogin: gatewayLogin_1.default(virtual),
    getTimerList: getTimerList_1.default(virtual),
    heartbeat: heartbeat_1.default(virtual),
    reportDevInfo: reportDevInfo_1.default(virtual),
    reportSubDevInfo: reportSubDevInfo_1.default(virtual),
    requestVerify: requestVerify_1.default(virtual),
    timerReport: timerReport_1.default(virtual)
}); });



// WEBPACK FOOTER //
// ./src/actions/send/actions/index.ts